/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

document.addEventListener("DOMContentLoaded", function () {
  const urlParams = new URLSearchParams(window.location.search);
  // console.log('urlParams.get("hideRegionPopup")', urlParams.get("hideRegionPopup"));

  if (urlParams.get("hideRegionPopup") === "true" || localStorage.getItem("hideRegionPopup") === "true") {
      document.querySelector(".js-popup-cookies").style.display = "none";

      localStorage.setItem("hideRegionPopup", "true");

      const newUrl = window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
  }
});